import React from 'react';
import { i18n } from '../utils';

i18n.initialize();

const images = {
  visa: require('../assets/card/visa.svg'),
  master: require('../assets/card/master.svg'),
  amex: require('../assets/card/amex.png'),
  diners: require('../assets/card/diners.svg'),
  discover: require('../assets/card/discover.png'),
  jcb: require('../assets/card/jcb.svg')
}

const FormHeader = ({ cardsImage = ""}) => {
  i18n.changeLanguage(localStorage.getItem('productLanguage'));

  return (
    <header>
      <h2 className="mt-0">{ i18n.t('pay_with_credit_and_debit') }</h2>
      <p>{ i18n.t('secure_transactions') }</p>
      <div>
        <p className="text-uppercase text-muted small mb-0">{ i18n.t('cards')}</p>
        <div className="cards">
          { cardsImage.split("_").map(card => <div key={card}><img src={images[card]} alt={card} /></div> ) }
        </div>
      </div>
    </header>
  )
}

export default FormHeader



// WEBPACK FOOTER //
// ./client/components/FormHeader.js